import { ValidateEmail } from '../../../../validators/email';
import { ValidatePhone } from '../../../../validators/phone';
import { ValidateId } from '../../../../validators/id';

export const requiredRule = (intl: any, param: string) => ({
  required: {
    value: true,
    message: intl.formatMessage({ id: 'pacientes.generic.errors.required' }, {
      param: intl.formatMessage({ id: `pacientes.generic.titles.${param}` }),
    }),
  },
});
export const requireAcompanyanteRule = (intl: any, param: string, edad:any, configuraciones:any) => {
  let edadMinimaTutor = parseInt(configuraciones?.edad_minima_no_oblig_tutor, 10);
  let edadMaximaTutor = parseInt(configuraciones?.edad_maxima_no_oblig_tutor, 10);
  if (edadMinimaTutor === undefined || edadMinimaTutor === null || Number.isNaN(edadMinimaTutor)) edadMinimaTutor = 0;
  if (edadMaximaTutor === undefined || edadMaximaTutor === null || Number.isNaN(edadMaximaTutor)) edadMaximaTutor = 1000;
  const value = (edad <= edadMinimaTutor || edad >= edadMaximaTutor);
  return {
    required: {
      value,
      message: intl.formatMessage({ id: 'pacientes.generic.errors.required' }, {
        param: intl.formatMessage({ id: `pacientes.generic.titles.${param}` }),
      }),
    },
  };
};

export const inputTextGenericRules = (intl: any, param: string) => {
  if (param === 'nombre_1' || param === 'apellido_1' || param === 'apellido_2') {
    return {
      required: {
        value: true,
        message: intl.formatMessage({ id: 'pacientes.generic.errors.required' }, {
          param: intl.formatMessage({ id: 'pacientes.generic.titles.name_last' }),
        }),
      },
      minLength: {
        value: 2,
        message: intl.formatMessage({ id: 'pacientes.generic.errors.text_min_length' }, {
          textLength: 2,
        }),
      },
    };
  }
  return {
    required: {
      value: true,
      message: intl.formatMessage({ id: 'pacientes.generic.errors.required' },
        { param: intl.formatMessage({ id: `pacientes.generic.params.${param}` }) }),
    },
    minLength: {
      value: 5,
      message: intl.formatMessage({ id: 'pacientes.generic.errors.text_min_length' }, {
        textLength: 5,
      }),
    },
  };
};
export const inputEmailRules = (intl: any, param: string | undefined) => ({
  required: {
    value: false,
    message: intl.formatMessage({ id: 'pacientes.generic.errors.required' },
      { param: intl.formatMessage({ id: `pacientes.generic.params.${param}` }) }),
  },
  validate: {
    checkMail: (email: string) => ValidateEmail(email)
      || intl.formatMessage({ id: 'pacientes.generic.errors.email' }),
  },
});

export const inputPhoneRules = (intl: any, param: string | undefined, control: any) => ({
  validate: {
    checkPhone: () => {
      const { getValues } = control;
      if (param === 'telefono_1') {
        if (getValues('telefono_1') !== '') {
          if (ValidatePhone('telefono_1', getValues('telefono_1'))) {
            return true;
          }
          return intl.formatMessage({ id: 'pacientes.generic.errors.number_invalid' });
        }
      }
      if (param === 'telefono_2') {
        if (getValues('telefono_2') !== '') {
          if (ValidatePhone('telefono_2', getValues('telefono_2'))) {
            return true;
          }
          return intl.formatMessage({ id: 'pacientes.generic.errors.number_invalid' });
        }
      }
      return true;
    },
  },
});
export const inputIdRules = (intl: any, param:string, country: string, idType: any) => ({
  validate: {
    checkId: (idNum: string) => {
      if (ValidateId(country, idType, idNum)) { return true; }
      return intl.formatMessage({
        id: idType !== null ? 'pacientes.generic.errors.valid_id' : 'pacientes.generic.errors.required_id_type',
      });
    },
  },
});

export const requiredRuleEyeChart = (intl: any, param: string) => ({
  required: {
    value: true,
    message: intl.formatMessage({ id: 'pacientes.generic.errors.select' }, {
      param: intl.formatMessage({ id: `pacientes.generic.errors.${param}` }),
    }),
  },
});

export const requiredRuleEjeCilindro = (intl: any, param: string, param1:string, control:any, clearErrors:any) => ({
    validate: (v:any) => {
      const { getValues } = control;
      if(getValues(param) != '' && getValues(param1) === ''){
        return false;
      }else if(getValues(param) === '' && getValues(param1) === ''){
        clearErrors(param);
        return true;
      }else if(getValues(param) != '' && getValues(param1) != ''){
        clearErrors(param);
        return true;
      }
      return false;
    },
});

export const esfRule = (intl: any, param: string) => ({
  // required: {
  //   value: true,
  //   message: intl.formatMessage({ id: 'pacientes.generic.errors.select' }, {
  //     param: intl.formatMessage({ id: `pacientes.generic.errors.${param}` }),
  //   }),
  // },
  validate: {
    checkMultiple: (value: number) => {
      if (value % 0.25 === 0) { return true; }
      return intl.formatMessage({ id: 'pacientes.generic.errors.email' },{
        param:" intl.formatMessage({ id: `pacientes.generic.errors.${param}` })",
      });
    },
  },
});
